import { toast as sonnerToast } from '../components/ui/toast'

export const toast = sonnerToast